module.exports = __webpack_public_path__ + "static/img/u120.df20558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/u120.png
// module id = bhVD
// module chunks = 1